/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleUpIcon20Light = forwardRef('ArrowFigureACircleUpIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9.5 13.5A.5.5 0 0 1 9 13V6.781l-2.116 2.54a.5.5 0 1 1-.768-.641l2.232-2.678a1.5 1.5 0 0 1 2.304 0l2.232 2.678a.5.5 0 0 1-.768.64L10 6.781V13a.5.5 0 0 1-.5.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 17a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15ZM3 9.5a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Z" })));
});
